<template>   
  <div>
    <v-toolbar flat color="white">
      <v-dialog v-model="dialog" max-width="500px">
        <v-btn slot="activator" color="primary" dark class="mb-2">
            New schedule
        </v-btn>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs6>
                  <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="editedItem.dateFrom"
                        lazy
                        transition="scale-transition"
                        width="290px"
                        left
                      >
                      <v-text-field
                        slot="activator"
                        v-model="editedItem.dateFrom"
                        label="Date from"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                        <v-date-picker v-model="editedItem.dateFrom" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                          <v-btn flat color="primary" @click="$refs.menu.save(editedItem.dateFrom);">OK</v-btn>
                         </v-date-picker>
                    </v-menu>
                  </v-flex>
                <v-flex xs6>
                    <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="editedItem.timeFrom"
                        lazy
                        transition="scale-transition"
                        left
                        max-width="290px"
                        min-width="290px"
                      >
                      <v-text-field
                        slot="activator"
                        v-model="editedItem.timeFrom"
                        label="Time from"
                        prepend-icon="access_time"
                        readonly
                      ></v-text-field>
                      <v-time-picker
                        v-if="menu2"
                        v-model="editedItem.timeFrom"
                        full-width
                        @click:minute="$refs.menu2.save(editedItem.timeFrom)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs6>
                  <v-menu
                        ref="menu3"
                        v-model="menu3"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="editedItem.dateTo"
                        lazy
                        transition="scale-transition"
                        left
                        min-width="290px"
                      >
                      <v-text-field
                        slot="activator"
                        v-model="editedItem.dateTo"
                        label="Date to"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                        <v-date-picker v-model="editedItem.dateTo" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                          <v-btn flat color="primary" @click="$refs.menu3.save(editedItem.dateTo);">OK</v-btn>
                         </v-date-picker>
                    </v-menu>
                  </v-flex>
                <v-flex xs6>
                    <v-menu
                        ref="menu4"
                        v-model="menu4"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="editedItem.timeTo"
                        lazy
                        transition="scale-transition"
                         left
                        max-width="290px"
                        min-width="290px"
                      >
                      <v-text-field
                        slot="activator"
                        v-model="editedItem.timeTo"
                        label="Time to"
                        prepend-icon="access_time"
                        readonly
                      ></v-text-field>
                      <v-time-picker
                        v-if="menu4"
                        v-model="editedItem.timeTo"
                        full-width
                        @click:minute="$refs.menu4.save(editedItem.timeTo)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="closeModal">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="saveModal">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
        :headers="headers"
        :items="schedules"
        class="elevation-1">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.dateFrom | date }}</td>
        <td>{{ props.item.dateTo | date }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editSchedule(props.item)"
            >
            edit
            </v-icon>
            <v-icon
            small
            @click="deleteSchedule(props.item)"
            >
            delete
          </v-icon>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { db } from '@/services/firebase';
import { parse } from 'date-fns'

export default {
    name: 'EditEventSchedules',
    props: ['id', 'event'],
    data: () => ({
      dialog: false,
      editedIndex: -1,
      editedItem: {
        dateFrom: new Date().toISOString().substr(0, 10),
        dateTo: new Date().toISOString().substr(0, 10),
        timeTo: '00:00',
        timeFrom: '00:00',
      },
      defaultItem: {
        dateFrom: new Date().toISOString().substr(0, 10),
        timeFrom: '00:00',
        dateTo:new Date().toISOString().substr(0, 10),
        timeTo: '00:00',
      },
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      modal: false,
      headers: [
        {
          text: 'Date From',
          sortable: false,
          value: 'dateFrom'
        },
        { text: 'Date to', value: 'dateTo', sortable: false },
        { text: 'Actions', value: 'name', sortable: false }
      ],
    }),
    firestore () {
      return {
        schedules: db.collection('events')
          .where('eventTemplateId', '==', this.id)
          .orderBy('dateFrom','desc')
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New schedule' : 'Edit schedule'
      }
    },
    watch: {
      dialog (val) {
        val || this.closeModal()
      }
    },
    methods: {
      editSchedule(item) {

      },
      deleteSchedule(item) {

      },
      closeModal() {
        this.dialog = false
        setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
        }, 300)
      },
      async saveModal () {
        const dateFrom = parse(`${this.editedItem.dateFrom} ${this.editedItem.timeFrom}`);
        const dateTo = parse(`${this.editedItem.dateTo} ${this.editedItem.timeTo}`);
        const newSchedule = await db.collection('events').add({
            authorId: this.event.authorId,
            description: this.event.description,
            location: this.event.location,
            status: this.event.status,
            title: this.event.title,
            dateFrom: dateFrom,
            dateTo: dateTo,
            eventTemplateId: this.event['.key']
         });
          this.closeModal();
      }
    }
}
</script>
